export const FETCH_SALON_TAGS_LIST_REQUEST = 'FETCH_SALON_TAGS_LIST_REQUEST';
export const FETCH_SALON_TAGS_LIST_SUCCESS = 'FETCH_SALON_TAGS_LIST_SUCCESS';
export const FETCH_SALON_TAGS_LIST_FAILURE = 'FETCH_SALON_TAGS_LIST_FAILURE';
